import React, {useEffect, useState} from 'react'
import { Row, Col} from 'react-bootstrap'
import { useDispatch, useSelector, RootStateOrAny } from 'react-redux'
// import { addProtondxAdminSampleID, updateProtondxAdminSampleID, deleteProtondxAdminSampleID } from '../../../redux-store/actions/protondxAdminActions'
import { addSampleIDAPI, updateSampleIDAPI, deleteSampleIDAPI } from './SampleTestAPI'

const SampleIdComponent = (props) => {

  // var {processing, success, error} = useSelector((state : RootStateOrAny)=>state.protondxAdminAddSampleId)
  // var {processing3, success3, error3} = useSelector((state : RootStateOrAny)=>state.protondxAdminDeleteSampleId)
  // var {processing2, success2, error2} = useSelector((state : RootStateOrAny)=>state.protondxAdminUpdateSampleId)

  const dispatch = useDispatch()

  const [error, setError] = useState(false)

  const [sampleid, setSampleId] = useState('')
  const [sampleenabled, setSampleEnabled] = useState(false)
  const [id, setId] = useState(null) //DB id
  const [editmode, setEditMode] = useState(false)

  useEffect(()=>{
    if(props.sampleid){
      setSampleId(props.sampleid)
    }
    if(props.sampleenabled){
      setSampleEnabled(props.sampleenabled)
    }
    //set initial data here
    if(props.dbid){
      setId(props.dbid)
    }
    // setEditMode(false)
  },[props])


  const addSampleID = async (e)=>{
      e.preventDefault()
      if(typeof(sampleenabled) === 'undefined'){
        setSampleEnabled(false)
      }

      if(sampleid){
        //await dispatch(addProtondxAdminSampleID(sampleid, sampleenabled))
        let success = await addSampleIDAPI(sampleid, sampleenabled)
        if(success && success.status_code == 200){
          var newobj = {}
          newobj.sampleid = sampleid
          if(!sampleenabled){
            newobj.sampleenabled = false
            setSampleEnabled(false)
          }else{
            newobj.sampleenabled = sampleenabled
          }
          // if(id !== null){
          //   newobj._id = Math.floor(Math.random()*10000) //for testing
          // }else{
          //   newobj._id = id //needs to come from db
          // }else{
            newobj._id = success.id
          // }
          props.sampleArray.push(newobj)
          props.setNewSample(true)
          setError(false)
        }else{
          setError(true)
        }
      }
  }

  const updateSampleID = async (e)=>{
      e.preventDefault()
      if(sampleid && editmode === true){
          //await dispatch(updateProtondxAdminSampleID(id, sampleid, sampleenabled))
          const success2 = await updateSampleIDAPI(id, sampleid, sampleenabled)
          if(success2 && success2.status_code == 200){
            props.updateSampleArray(id, sampleid, sampleenabled, true)
            setError(false)
            setEditMode(false) //after the api call is successful
            return
          }else{
            setError(true)
          }
      }
      // props.executeCommand("updateSampleId", id, sampleid, sampleenabled)
      setEditMode(true)
  }

  const deleteSampleID = async (e)=>{
      e.preventDefault()
      if(sampleid){
        //await dispatch(deleteProtondxAdminSampleID(id))
        let success3 = await deleteSampleIDAPI(id)
        if(success3 && success3.status_code == 200){
          props.updateSampleArray(id, null, null, false)
          setError(false)
        }else{
          setError(true)
        }
      }
  }

  const editingModeInit = (value, checkbox) => {
    if(checkbox === true){
      setSampleEnabled(value)
    }else{
      setSampleId(value)
    }
    setEditMode(true)
  }

  return (
    <form>
      <Row>
          <Col sm="7">
              <input
                  autoFocus
                  type='text'
                  value={error ? "NETWORK ERROR" : sampleid}
                  required
                  onChange={(event)=>editingModeInit(event.target.value, false)}
                  className='modal-input-box'
                  style={{width: "100%"}}
              />
          </Col>
          <Col sm="1" style={{flexDirection: "row"}}>
            { sampleenabled ?
              <input
                  autoFocus
                  type='checkbox'
                  required
                  onChange={(event)=>editingModeInit(event.target.checked, true)}
                  checked
                  className="chkboxstyle"
              />
              :
              <input
                  autoFocus
                  type='checkbox'
                  required
                  onChange={(event)=>editingModeInit(event.target.checked, true)}
                  className="chkboxstyle"
              />
            }
            {/* sampleenabled ?
              <label className="px-2" style={{fontSize: "6pt"}}>Enabled</label>
              : <label className="px-2" style={{fontSize: "6pt"}}>Disabled</label>
            */}
          </Col>
          <Col sm="4">
          <div className="sample-operation">
            { (props && props.dbid === "") &&
              <button
                value=""
                onClick={(event)=>addSampleID(event)}
                className="dfaddbtn">
              </button> }
              <button
                value=""
                onClick={(event)=>updateSampleID(event)}
                className={ editmode === true ? "dfsavebtn" : "dfupdatebtn"}>
              </button>
              <button
                value=""
                onClick={(event)=>deleteSampleID(event)}
                className="dfdeletebtn">
              </button>
          </div>
          </Col>
      </Row>
    </form>
  )
}
export default SampleIdComponent
